const roles = {
	title: "Rolle",
	new_role: "Ny rolle",
	edit_role: "rediger rolle: {name}",
	view_role: "Vis rolle: {name}",
	detail_role: "Detakjer",
	permission_role: "{name}: gi tillatelser",
	list_title: "Roller",
	list_subtitle: "Redigere roller",
	create_title: "Opprett ny rolle",
	update_title: "Endre rolle",
	permission_btn: "Tillatelser",
	id: "ID",
	name: "Navn",
	slug: "Slug",
	type: "Type",
	check_all: "Velg alle",
	uncheck_all: "Fjern alle",
	check_all_access: "Velge alle (lese)",
	check_all_create: "Velge alle (opprette)",
	check_all_edit: "Velge alle (redigere)",
	check_all_delete: "Velge alle (slette)",
	maintained_by_admin: "Vedlikeholdes av XL3 admin",
};
export default roles;